import { render } from "./DateTimeDetail.vue?vue&type=template&id=04b60757"
import script from "./DateTimeDetail.vue?vue&type=script&lang=js"
export * from "./DateTimeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__